<template>
  <b-navbar
    toggleable="sm"
    type="dark"
    variant="primary"
    style="height: 4rem;"
  />
</template>

<script>
export default {};
</script>
